import { MgState, UserEntityInterface } from '@types';

export const supportDataUsersSelector = (store: MgState): UserEntityInterface[] =>
  store?.feedback.supportData.users;
